import {useMutation} from "@tanstack/react-query";
import {downloadFile} from "../../../../../util/FileDownload";
import {downloadShipmentFile} from "../../../../../api/order/OrdersApi";
import {OrdersShipmentDeliveryConfirmFileType} from "../interface";

export const useDownloadShipmentFile = () => {
    const {mutate} = useMutation({
        mutationFn: (data: OrdersShipmentDeliveryConfirmFileType) => downloadShipmentFile(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                downloadFile(res, variables.fileOrgname)
            }
        },
    });

    return {mutate};
};
